export default __webpack_public_path__ + "static/translate-63c61ac593af5ae53a8c5dbbe2d94ded.jpg";